import { App, GlobalStylesOverride } from "franchise-website";
import { NextPage } from "next";
import { NextSeo } from "next-seo";

const LandingPage: NextPage = () => {
	return (
		<>
			<NextSeo
				title="Sell more franchises in 90 days using tools and techniques pioneered by world-leading brands."
				description="We help franchise development teams deliver new sales within 90 days of deployment."
				canonical="https://mangomap.com/franchise"
				openGraph={{
					title:
						"Sell more franchises in 90 days using tools and techniques pioneered by world-leading brands.",
					description:
						"We help franchise development teams deliver new sales within 90 days of deployment.",
					url: "https://mangomap.com/franchise",
					site_name: "Mango Franchise",
					images: [
						{
							url: "/new-mangomap-assets/images/mangofranchiseog.jpg",
							width: 1182,
							height: 670,
							alt: "Mango Franchise",
							type: "image/jpg",
						},
					],
				}}
			/>
			<GlobalStylesOverride />
			<App />
		</>
	);
};

export default LandingPage;
